import React, { useEffect, useRef, useState } from "react";
import styles from "../Form.module.scss";

function TextInput({ substep, value, onChange, error, isReadOnly, isPassword, multiline }) {
  const config = substep?.input_text ?? {};
  const text = value?.string_value ?? "";
  const maxLength = config.max_length > 0 ? config.max_length : undefined;
  const [revealed, setRevealed] = useState(false);
  const textareaRef = useRef(null);

  useEffect(() => {
    if (!multiline || !textareaRef.current) return;
    textareaRef.current.style.height = "auto";
    textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
  }, [multiline, text]);

  const handleChange = (e) =>
    onChange(substep.substep_id, { string_value: e.target.value });

  if (multiline) {
    return (
      <div className={styles.fieldBody}>
        <textarea
          ref={textareaRef}
          className={`${styles.input} ${styles.textareaInput} ${error ? styles.inputError : ""}`}
          value={text}
          placeholder={config.placeholder || ""}
          maxLength={maxLength}
          disabled={isReadOnly}
          autoCapitalize="none"
          autoComplete="off"
          rows={2}
          onChange={handleChange}
        />
        {error && <div className={styles.fieldError}>{error}</div>}
      </div>
    );
  }

  return (
    <div className={styles.fieldBody}>
      <div className={isPassword ? styles.passwordWrap : undefined}>
        <input
          className={`${styles.input} ${error ? styles.inputError : ""}`}
          type={isPassword && !revealed ? "password" : "text"}
          value={text}
          placeholder={config.placeholder || ""}
          maxLength={maxLength}
          disabled={isReadOnly}
          autoCapitalize="none"
          autoComplete="off"
          onChange={handleChange}
        />
        {isPassword && (
          <button
            type="button"
            className={styles.eyeBtn}
            onClick={() => setRevealed((v) => !v)}
            tabIndex={-1}
            aria-label={revealed ? "Hide" : "Show"}
          >
            <img src={revealed ? "/logos/eye_open.svg" : "/logos/eye_close.svg"} alt="" />
          </button>
        )}
      </div>
      {error && <div className={styles.fieldError}>{error}</div>}
    </div>
  );
}

export default TextInput;
